import { render, staticRenderFns } from "./crear-formulario.vue?vue&type=template&id=2f4e8a7c&scoped=true&"
import script from "./crear-formulario.vue?vue&type=script&lang=js&"
export * from "./crear-formulario.vue?vue&type=script&lang=js&"
import style0 from "./crear-formulario.vue?vue&type=style&index=0&id=2f4e8a7c&scoped=true&lang=css&"
import style1 from "./crear-formulario.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e8a7c",
  null
  
)

export default component.exports